import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useEffect, useRef, useState } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'
import { assignMemberAsAdmin } from '../../services/updateMemberStatus'

export default function AssignAsCoOwnerOverlay({ overlay, member, groupId, onAssignAdmin }) {
  const [t] = useTranslation()
  const [loading, setLoading] = useState(false)
  const isCurrent = useRef(true)
  const newSettingsPageOn = useFeatureFlag('treeWeb_groupManagement_newSettingsPage').isOn

  useEffect(() => {
    isCurrent.current = true
    return () => {
      isCurrent.current = false
    }
  })
  const onClick = () => {
    setLoading(true)
    assignMemberAsAdmin(groupId, member.memberCisId)
      .then(() => {
        onAssignAdmin()
        overlay.close()
        return undefined
      })
      .catch((e) => {
        isCurrent.current && setLoading(false)
        console.error(e)
      })
  }

  return (
    <DialogOverlay
      {...overlay}
      title={t('group-management.assign-name-co-owner.heading', { name: member.userProfileName })}
    >
      <Paragraph size="sm">
        {newSettingsPageOn
          ? t('group-management.assign-co-owner.new-description')
          : t('group-management.assign-co-owner.description')}
      </Paragraph>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="cancel-assign-co-owner-button" onClick={overlay.close}>
            {t('common-ui:cancel.action')}
          </Button>
          <Button
            data-testid="assign-co-owner-button"
            emphasis="high"
            disabled={loading}
            onClick={onClick}
            Icon={loading ? NoticeLoading : undefined}
          >
            {t('group-management.assign-co-owner.action')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
